// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1K2S3","select":"Header_select__iYZWf","clinic":"Header_clinic__2fRee"};